import moment from 'moment';

// Jobs just moved, resized or dropped on the dispatch calendar. The server's
// search results lag a moment behind a save, so a refetch right after a drop
// can still return the old position: the card snapped back for a moment and
// then jumped forward on the next reload. Until the server's data agrees (or
// the edit is old), refetched events keep the position the user gave them.

const KEEP_FOR_MS = 20000;
const edits = new Map();

// fields: the event properties to keep (start, end, endForDisplay,
// realMinutes, resourceId…). Keyed by the calendar event id.
export function rememberCalendarEdit(id, fields) {
  if (id == null) return;
  edits.set(String(id), { fields, at: Date.now() });
}

const sameTime = (a, b) => {
  if (!a || !b) return !a && !b;
  return moment(a).isSame(moment(b), 'minute');
};

const serverHasCaughtUp = (event, fields) =>
  sameTime(event.start, fields.start) &&
  (fields.endForDisplay === undefined || sameTime(event.endForDisplay, fields.endForDisplay)) &&
  (fields.resourceId === undefined || String(event.resourceId) === String(fields.resourceId));

// Apply remembered edits to freshly fetched events (mutates and returns them).
export function applyCalendarEdits(events) {
  if (!edits.size) return events;
  const now = Date.now();
  events.forEach((event) => {
    const key = String(event.id);
    const edit = edits.get(key);
    if (!edit) return;
    if (now - edit.at > KEEP_FOR_MS || serverHasCaughtUp(event, edit.fields)) {
      edits.delete(key);
      return;
    }
    Object.assign(event, edit.fields);
  });
  return events;
}
